import { getDateStringFromDate } from "../../../helper_functions/date_time_formats";

class KDProfileData {
  constructor({
    id,
    vesselId,
    profileName,
    valuesList,
    draft,
    trim,
    windDirection,
    trueWind,
    lhv,
    fouling,
    minDate,
    maxDate,
    useLatestFouling,
  }) {
    this.id = id;
    this.vesselId = vesselId;
    this.profileName = profileName;
    this.valuesList = valuesList;
    this.draft = draft;
    this.trim = trim;
    this.windDirection = windDirection;
    this.trueWind = trueWind;
    this.lhv = lhv;
    this.fouling = fouling;
    this.minDate = minDate;
    this.maxDate = maxDate;
    this.useLatestFouling = useLatestFouling;

  }

  static defaultData() {
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
    const threeMonthsFromNow = new Date();
    threeMonthsFromNow.setMonth(threeMonthsFromNow.getMonth() + 3);

    return new KDProfileData({
      id: null,
      vesselId: null,
      profileName: "",
      valuesList: "9,10,11,12,13",
      draft: 10.0,
      trim: 0.0,
      trueWind: 3.0,
      windDirection: "Head Seas",
      lhv: 42000,
      fouling: 0.0,
      minDate: getDateStringFromDate(threeMonthsAgo),
      maxDate: getDateStringFromDate(threeMonthsFromNow),
      useLatestFouling: false,
    });
  }
}

class KDProfileCreateData {
  constructor({
    profileName,
    valuesList,
    draft,
    trim,
    windDirection,
    trueWind,
    lhv,
    fouling,
    minDate,
    maxDate,
    useLatestFouling = false,
  }) {
    this.profileName = profileName;
    this.valuesList = valuesList;
    this.draft = draft;
    this.trim = trim;
    this.windDirection = windDirection;
    this.trueWind = trueWind;
    this.lhv = lhv;
    this.fouling = fouling;
    this.minDate = minDate;
    this.maxDate = maxDate;
    this.useLatestFouling = useLatestFouling;
  }

  static defaultData() {
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
    const threeMonthsFromNow = new Date();
    threeMonthsFromNow.setMonth(threeMonthsFromNow.getMonth() + 3);

    return new KDProfileCreateData({
      profileName: "",
      valuesList: "9,10,11,12,13",
      draft: 10.0,
      trim: 0.0,
      windDirection: "Head Seas",
      trueWind: 3.0,
      lhv: 42000,
      fouling: 0.0,
      minDate: getDateStringFromDate(threeMonthsAgo),
      maxDate: getDateStringFromDate(threeMonthsFromNow),
      useLatestFouling: false,
    });
  }

}

export { KDProfileData, KDProfileCreateData };
